import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/ai-astrologer"

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const Add = async (values) => {
    return await axiosInstance(options).post(`${path}/add`, values);
}

export const Edit = async (values) => {
    return await axiosInstance(options).put(`${path}/edit`, values);
}

export const Delete = async (values) => {
    return await axiosInstance(options).post(`${path}/delete`, values)
}

export const changepassword = async (values) => {
    return await axiosInstance(options).post(`${path}/change-password`, values);
}

export const Details = async (id) => {
    return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
}

export const Status = async (values) => {
    return await axiosInstance(options).put(`${path}/change-status`, values)
}

export const ApproveAstrologerStatus = async (values) => {
    return await axiosInstance(options).put(`${path}/account-approval`, values)
}

export const SetInstantPrice = async (values) => {
    return await axiosInstance(options).put(`${path}/set-instant-price`, values)
}

export const GetAllAstrologer = async (values) => {
    return await axiosInstance(options).post(`${path}/all-astrologer`, values)
}

export const GetAllAiAstrologers = async () => {
    return await axiosInstance(options).get(`${path}/all`);
}

export const ChangeAstrologerPassword = async (values) => {
    return await axiosInstance(options).post(`${path}/change-user-password`, values);
}

export const AstrologerCallLogs = async (values) => {
    return await axiosInstance(options).post(`${path}/call-logs`, values);
}

export const AstrologerPerformanceSummary = async (id) => {
    return await axiosInstance(options).get(`${path}/performance-summary?astrologer_id=${id}`);
}

export const GetRatings = async (values) => {
    return await axiosInstance(options).post(`${path}/get-ratings`, values);
}

export const DeleteRatings = async (values) => {
    return await axiosInstance(options).post(`${path}/delete-ratings`, values);
}

export const UpdateAiFreeStatus = async (data) => {
    return await axiosInstance(options).post(
        `${path}/update-ai-free-status`,
        data
    );
};

export const UpdateTopStatus = async (data) => {
    return await axiosInstance(options).post(
        `${path}/update-top-status`,
        data
    );
};

export const UpdatePujaSortOrder = async (data) => {
    return await axiosInstance(options).post(
        `${path}/update-puja-sort-order`,
        data
    );
};

